import { Link } from 'react-router-dom';
import { GameLayout } from './GameLayout';

export function ZayacLanding() {
  return (
    <GameLayout>
      <ZayacStyles />
      <span className="zy-label">/ Заяц Live · игра на ассоциации и блеф</span>
      <h1 className="zy-landing-title">
        Заяц без <span className="accent-word">ведущего</span>.
      </h1>
      <p className="zy-lede">
        Все получают секретное слово — кроме одного. Этот один — Заяц. Все по очереди говорят по одной ассоциации,
        а потом голосуют, кто не знал слова. Приложение раздаёт слова, ведёт очерёдность, считает голоса и очки.
      </p>

      <div className="zy-actions">
        <Link to="/play/zayac/create" className="btn-primary lg">
          Создать игру →
        </Link>
        <Link to="/rooms" className="btn-ghost lg">
          Войти по коду
        </Link>
      </div>

      <div className="zy-features">
        <Feature n="01" title="Слово втайне" text="Сервер знает слово и Зайца, клиент — нет. Каждый видит только свой экран. Заяц видит, что он Заяц, и больше ничего." />
        <Feature n="02" title="Очерёдность" text="Игроки говорят по очереди — телефон сам подскажет, чей ход. Нажал «я сказал» — ход переходит дальше." />
        <Feature n="03" title="Голосование" text="Все голосуют, кто Заяц. Публичный счёт голосов, без «кто кого». Заяц среди лидеров голосов — пойман." />
        <Feature n="04" title="Очки и история" text="Поймали Зайца — +1 мирным. Заяц сбежал — +2 зайцу. Несколько раундов, финальный счёт и сохранённая история партии." />
      </div>

      <div className="zy-rules">
        <h2>Как играть</h2>
        <ol>
          <li>Создатель вводит имена (от 3 до 12) или грузит сохранённую команду.</li>
          <li>Показывает QR. Все выбирают своё имя и жмут «войти».</li>
          <li>«Старт» — приложение выбирает слово и Зайца, раздаёт экраны.</li>
          <li>По очереди каждый говорит одну ассоциацию к слову. Заяц импровизирует.</li>
          <li>Обсуждение и голосование: кого считаете Зайцом — выбирайте в приложении.</li>
          <li>Раскрытие: кто был Зайцем и какое было слово. Очки начисляются автоматически.</li>
          <li>Так несколько раундов. В конце — финальный счёт и победитель.</li>
        </ol>
      </div>
    </GameLayout>
  );
}

function Feature({ n, title, text }: { n: string; title: string; text: string }) {
  return (
    <div className="zy-feature">
      <span className="mono" style={{ fontSize: 11, color: 'var(--ink-faint)', letterSpacing: '0.16em' }}>
        {n}
      </span>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

function ZayacStyles() {
  return (
    <style>{`
      .zy-landing-title { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 88px; line-height: 1.02; letter-spacing: -.015em; margin: 12px 0 0; }
      .zy-lede { max-width: 640px; font-size: 17px; line-height: 1.55; color: var(--ink-dim); margin: 24px 0 40px; }
      .zy-actions { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 64px; }
      .zy-features { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 64px; }
      .zy-feature { background: var(--bg2); border: 1px solid var(--line); border-radius: var(--radius-card); padding: 24px; }
      .zy-feature h3 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 26px; margin: 12px 0 8px; letter-spacing: -.005em; }
      .zy-feature p { font-size: 13px; line-height: 1.5; color: var(--ink-dim); margin: 0; }
      .zy-rules h2 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 40px; letter-spacing: -.01em; margin: 0 0 20px; }
      .zy-rules ol { max-width: 640px; padding-left: 20px; color: var(--ink-dim); line-height: 1.7; font-size: 15px; }
      .zy-rules li { margin-bottom: 8px; }
      @media (max-width: 900px) { .zy-features { grid-template-columns: 1fr 1fr; } .zy-landing-title { font-size: 56px; } }
      @media (max-width: 560px) { .zy-features { grid-template-columns: 1fr; } }
    `}</style>
  );
}
